import { render, staticRenderFns } from "./WithAcc.vue?vue&type=template&id=480e6081&scoped=true&"
import script from "./WithAcc.vue?vue&type=script&lang=js&"
export * from "./WithAcc.vue?vue&type=script&lang=js&"
import style0 from "./WithAcc.vue?vue&type=style&index=0&id=480e6081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e6081",
  null
  
)

export default component.exports